export default __webpack_public_path__ + "static/bariol_serif_bold-webfont-0148c1a7a6a866374a51afeece20a141.svg";